import React from 'react';

import Text from 'components/shared/text';
import Container from 'components/shared/container';

const PropertyValues = ({ values }) => {
  return (
    <Container>
      <Text
        width="100%"
        text="Values"
        fontSize="18px"
        textAlign="left"
        fontWeight="bold"
        margin="20px 0 10px 0"
      />
      <section className="modal-value-table">
        {values ? (
          values?.map((value) => (
            <div key={value?.name} className="modal-value-table-row">
              <Text
                width="10%"
                text={value?.name}
                textAlign="left"
                fontWeight="bold"
                margin="0 20px 10px 0"
                fontSize={value.type === 'big' ? '12px' : '16px'}
              />
              <Text
                width="70%"
                fontSize="14px"
                textAlign="left"
                lineHeight={1.5}
                margin="0 auto 0 20px"
                text={value?.description}
              />
            </div>
          ))
        ) : (
          <Text
            textAlign="left"
            margin="10px 0 0 0"
            text="This tag only support global attributes."
          />
        )}
      </section>
    </Container>
  );
};

export default PropertyValues;
